import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import FileWithProgress from 'components/FileUpload/types/fileWithProgress';
import PhotoAlbumIcon from '@mui/icons-material/PhotoAlbum';
import ProgressWithLabel from 'components/ProgressWithLabel';
import { Box } from '@mui/material';
import {
	UploadedFileListItemCloseButton,
	UploadedFileListItemLink,
	UploadedFileListItemText,
	UploadedFileListItemWrap,
} from './style';

interface PropsType {
	link: FileWithProgress;
	handleDelete?: (file: string | File) => void;
}

function UploadedFileListItem({ link, handleDelete }: PropsType) {
	const showProgressBar = !!link?.progress && !link.url;
	const { error } = link;
	const errorStyle = error && { color: '#FF0000' };
	return (
		<UploadedFileListItemWrap sx={{ opacity: showProgressBar ? 0.5 : 1 }}>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
				<PhotoAlbumIcon sx={{ fontSize: '24px', ...errorStyle }} color="primary" />
				<Box width="80%">
					<Box display="flex" alignItems="center" gap="12px">
						<UploadedFileListItemText sx={errorStyle} variant="body1">
							{link.name}
						</UploadedFileListItemText>
						{link.url && (
							<UploadedFileListItemLink href={link?.url} target="_blank">
								Preview
							</UploadedFileListItemLink>
						)}
					</Box>
					{showProgressBar && <ProgressWithLabel value={link.progress} />}
				</Box>
			</Box>
			{error && (
				<UploadedFileListItemText sx={{ maxWidth: '100%', ...errorStyle }} variant="body1">
					{error}
				</UploadedFileListItemText>
			)}
			{!!handleDelete && (
				<UploadedFileListItemCloseButton
					onClick={() => handleDelete(link.file || link.url!)}
					// @ts-ignore
					isError={error}
					size="small"
				>
					<CloseIcon sx={{ fontSize: '16px' }} />
				</UploadedFileListItemCloseButton>
			)}
		</UploadedFileListItemWrap>
	);
}

export default UploadedFileListItem;
